import BasePostGridSlider from "@PegasusCore/pegasus-one-post-grid-slider/src/script";

class PostGridSlider extends BasePostGridSlider {
    init() {
        super.init();
        this.observeSlideChanges();
    }

    observeSlideChanges() {
        const observer = new MutationObserver(() => this.updateArrowState());
        const slides = this.$el.querySelectorAll(".slide");

        slides.forEach(slide => {
            observer.observe(slide, { attributes: true, attributeFilter: ["class"] });
        });

        this.updateArrowState(); // Run initially to set correct opacity
    }

    updateArrowState() {
        this.$nextTick(() => {
            const slides = this.$el.querySelectorAll(".slide");
            const prevButton = this.$el.querySelector(".prev-button");
            const nextButton = this.$el.querySelector(".next-button");
    
            const selectedIndex = Array.from(slides).findIndex(slide =>
                slide.classList.contains("is-selected")
            );
    
            if (prevButton) prevButton.style.opacity = selectedIndex === 0 ? "0.5" : "1";
            if (nextButton) nextButton.style.opacity = selectedIndex === slides.length - 1 ? "0.5" : "1";
        });
    }    

     /**
     * Handle drag start
     */
     onDragStart(event) {

        return false;
    }
    
    scrollSlide(slide, animate) {
        const selectedSlide = this.slides[slide];

        // If only one slide, keep it at the left-most position
        if (this.slides.length === 1) {
            this.carousel.style.transform = `translateX(0px)`;
            return;
        }

        // get the x position of the selected slide
        let slideX = selectedSlide.getBoundingClientRect().left;
        const currentTranslate = this.getSliderCurrentTranslate();
        // get the x position of the this.carouselWrapper
        let wrapperX = this.carouselWrapper.getBoundingClientRect().left;

        // calculate the distance to translate
        let distance = wrapperX - slideX + currentTranslate;

        if (slide === 0) {
            distance = 0;
        }

        if (slide === this.slides.length - 1) {
            slideX = selectedSlide.getBoundingClientRect().right;
            wrapperX =
                this.carouselWrapper.getBoundingClientRect().left +
                this.carouselWrapper.offsetWidth;
            distance = wrapperX - slideX + currentTranslate;
        }

        this.isChanging = true;

        if (!animate) {
            this.carousel.classList.add("no-transition");
        }

        this.carousel.style.transform = `translateX(${distance}px)`;

        if (!animate) {
            this.carousel.offsetWidth; // Trigger reflow
            this.carousel.classList.remove("no-transition");
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGridSlider", (autoplay, infinite, slidesInView) => new PostGridSlider(autoplay, infinite, slidesInView));

    Alpine.data("filterDropdown", () => ({
        open: false,
        labelFilters: {},

        get filterLabel() {
            const count = Object.keys(this.labelFilters).length;
            if (count === 0) return "Show all";
            if (count === 1) return Object.values(this.labelFilters)[0];
            return "Showing Multiple";
        },

        updateLabelFilter(slug, name) {
            if (!this.labelFilters[slug]) {
                this.labelFilters[slug] = name;
            } else {
                delete this.labelFilters[slug];
            }
        },

        clearLabelFilters() {
            this.labelFilters = {};
        }
    }));
});
